import { Grid } from '@mui/material';
import { Outlet } from 'react-router';

import { GridContainer } from './ContentGrid.styled';

function ContentGrid() {
  return (
    <GridContainer container>
      <Grid item xl={12} lg={12} md={12} xs={12}>
        <Outlet />
        {/* {scenarioLoading ? (
          <Loading />
        ) : selectedScenario ? (
          <ShiftProvider key={selectedScenario} scenario={selectedScenario}>
            <Outlet />
          </ShiftProvider>
        ) : (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100%',
            }}
          >
            <EmptyBox sx={{ maxHeight: '5rem' }}>
              {TEXT_CONTENT.NO_SHIFT_MAP_OPTIONS}
            </EmptyBox>
          </Box>
        )} */}
      </Grid>
    </GridContainer>
  );
}

export default ContentGrid;
